const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    const string = s.split('_').map(str => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase())
    return string.join(' ')
}

const snakeCase = string => {
    return string.replace(/\W+/g, " ")
        .split(/ |\B(?=[A-Z])/)
        .map(word => word.toLowerCase())
        .join('_');
};

const responsiveFontSize = (fontSize) => {
    const a = fontSize > 25 ? 3 : 1
    return Math.min(Math.max(25 + Math.ceil((fontSize - 25) / a), 12), 50)
}

const genHtmlResponsive = (html) => {
    let htmlSplit = html.split('"')
    for (let i = 0; i < htmlSplit.length; i++) {
        if (htmlSplit[i].includes('font-size')) {
            let fontSize = htmlSplit[i].substring(htmlSplit[i].indexOf("font-size:") + 11, htmlSplit[i].lastIndexOf("px"))
            htmlSplit[i] = htmlSplit[i].replace(fontSize, responsiveFontSize(fontSize))
        }
    }
    return htmlSplit.join('"')
}
const decodeSpecialChars = (text) => {
    var map = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#039;': "'"
    };
    return text.replace(/&amp;|&lt;|&gt;|&quot;|&#039;/g, function(m) {return map[m];});
}

export {
    capitalize,
    snakeCase,
    responsiveFontSize,
    genHtmlResponsive,
    decodeSpecialChars,
}
export default {
    capitalize,
    snakeCase,
    responsiveFontSize,
    genHtmlResponsive,
    decodeSpecialChars,
}